import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ISalesFunnelLayoutChild } from '../shared/sales-funnel-child.module';

@Component({
  selector: 'app-customer-offer',
  standalone: true,
  imports: [],
  templateUrl: './customer-offer-component.html',
  styleUrls: ['./customer-offer-component.scss'],
})
export class CustomerOfferComponent implements ISalesFunnelLayoutChild {
  private router = inject(Router);

  salesFunnelIndex = 3;

  goBack(): void {
    this.router.navigate(['/customer-details']);
  }

  submitOrder(): void {
    this.router.navigate(['/order-confirmation']);
  }
}
